import { UserState } from '../redux/states'
import { BaseAction } from './actions'
import { User } from './user'

export enum UserActionTypes {
    USER_SUCCESS = 'USER_SUCCESS',
    USER_TOKEN = 'USER_TOKEN',
    USER_REQUEST = 'USER_REQUEST',
    USER_LOGOUT = 'USER_LOGOUT',
    USER_ERROR = 'USER_ERROR',
    USER_INFO_REQUEST = 'USER_INFO_REQUEST',
    USER_INFO_SUCCESS = 'USER_PORTAL',
    USER_PORTAL = 'USER_PORTAL',
    USER_PERMISSIONS_SUCCESS = 'USER_PERMISSIONS_SUCCESS',
    USER_SWITCH_LOCALE_SUCCESS = 'USER_SWITCH_LOCALE_SUCCESS',
    USER_PICMGMT_PERMISSIONS_SUCCESS = 'USER_PICMGMT_PERMISSIONS_SUCCESS',
    USER_OCH_PERMISSIONS_SUCCESS = 'USER_OCH_PERMISSIONS_SUCCESS',
    USER_SVTC_PERMISSIONS_SUCCESS = 'USER_SVTC_PERMISSIONS_SUCCESS',
    SMARTLY_PERMISSION_UPDATED = 'SMARTLY_PERMISSION_UPDATED',
}

export class UserAction extends BaseAction {
    static UserRequest = (): any => {
        return new UserAction(UserActionTypes.USER_REQUEST, {}).onDispatch()
    }

    static UserSuccess = (payload: any): any => {
        return new UserAction(
            UserActionTypes.USER_SUCCESS,
            payload
        ).onDispatch()
    }

    static ProfileInfoRequest = (): any => {
        return new UserAction(UserActionTypes.USER_REQUEST, {}).onDispatch()
    }

    static UserToken = (payload: any): any => {
        return new UserAction(UserActionTypes.USER_TOKEN, payload).onDispatch()
    }

    static UserSwitchLocaleSuccess = (payload: any): any => {
        return new UserAction(
            UserActionTypes.USER_SWITCH_LOCALE_SUCCESS,
            payload
        ).onDispatch()
    }

    static UserLogout = (): any => {
        return new UserAction(UserActionTypes.USER_LOGOUT, {}).onDispatch()
    }
    static UserPermissionsSuccess = (payload: any): any => {
        return new UserAction(
            UserActionTypes.USER_PERMISSIONS_SUCCESS,
            payload
        ).onDispatch()
    }
    static UserPicMgmtPermissionsSuccess = (payload: any): any => {
        return new UserAction(
            UserActionTypes.USER_PICMGMT_PERMISSIONS_SUCCESS,
            payload
        ).onDispatch()
    }
    static UserOchPermissionsSuccess = (payload: any): any => {
        return new UserAction(
            UserActionTypes.USER_OCH_PERMISSIONS_SUCCESS,
            payload
        ).onDispatch()
    }
    static UserSvtConsolePermissionsSuccess = (payload: any): any => {
        return new UserAction(
            UserActionTypes.USER_SVTC_PERMISSIONS_SUCCESS,
            payload
        ).onDispatch()
    }

    static UserError = (payload: any): any => {
        return new UserAction(UserActionTypes.USER_ERROR, payload).onDispatch()
    }
    static UserPortal = (code: string): any => {
        return new UserAction(UserActionTypes.USER_PORTAL, code).onDispatch()
    }
}
